export const dateTimeFormatWithoutMiliSeconds = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const defaultDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const noTimeZoneDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const defaultDateFormatForBeServices = 'YYYY-MM-DD';
export const defaultDateFormat = 'MM/DD/YY';
export const dateFormatLongYear = 'MM/DD/YYYY';
export const textMonthDateFormat = 'MMMM D, YYYY';
export const dateTimeFormatForUsers = 'MM/DD/YYYY HH:mm A';
